/* global braintree: true */
/* global paypal: true */
/* global process: true */

import { getLocaleWithCountryCode } from '../intl/languages';
import { sendError } from '../appsignal';

const SCRIPT_ID = 'paypal-checkout-script';

// This function loads the script which only happens
// when the user explicitly decide to use PayPal
function loadPayPalCheckoutScript(callback) {

  const existingScript = document.getElementById(SCRIPT_ID);

  if (!existingScript) {
    const script = document.createElement('script');
    script.src = 'https://www.paypalobjects.com/api/checkout.js';
    script.id = SCRIPT_ID;
    document.body.appendChild(script);

    script.onload = function(){
      callback && callback();
    }
    return;
  }

  existingScript && callback && callback();
}

function renderPayPalBtn(elementId, braintreeToken, config) {
  const buttonStyle =
    config.checkoutStep === 2
      ? {
          color: 'blue',
          shape: 'rect',
          size: 'small',
          label: 'buynow',
        }
      : {
          color: 'gold',
          shape: 'pill',
          size: 'small',
          label: 'checkout',
        };

  braintree.client.create(
    {
      authorization: braintreeToken,
    },
    function(clientErr, clientInstance) {
      // Stop if there was a problem creating the client.
      // This could happen if there is a network error or if the authorization
      // is invalid.
      if (clientErr) {
        // console.error('Error creating client:', clientErr);
        return;
      }

      // Create a PayPal Checkout component.
      braintree.paypalCheckout.create(
        {
          client: clientInstance,
        },
        function(paypalCheckoutErr, paypalCheckoutInstance) {
          // Stop if there was a problem creating PayPal Checkout.
          // This could happen if there was a network error or if it's incorrectly
          // configured.
          if (paypalCheckoutErr) {
            // console.error('Error creating PayPal Checkout:', paypalCheckoutErr);
            return;
          }

          // Set up PayPal with the checkout.js library
          paypal.Button.render(
            {
              env: process.env.ENV === 'development' ? 'sandbox' : 'production',
              commit: true, // This will add the transaction amount to the PayPal button

              style: buttonStyle,

              payment: function() {
                return paypalCheckoutInstance.createPayment({
                  flow: 'checkout', // Required
                  enableShippingAddress: true,
                  ...config.variables,
                });
              },
              locale: getLocaleWithCountryCode(config.language),

              onAuthorize: function(data) {
                return paypalCheckoutInstance
                  .tokenizePayment(data)
                  .then(function(payload) {
                    config.onAuthorize(payload.nonce);
                  });
              },

              onCancel: function(data) {
                config.onCancel && config.onCancel();
              },

              onError: function(err) {
                return;

              },
            },
            `#${elementId}`,
          )
            .then(function() {
              // The PayPal button will be rendered in an html element with the id
              // `paypal-button`. This function will be called when the PayPal button
              // is set up and ready to be used.
              config.onReady();
            })
            .catch(error => {
              const knownErrorMsg = `Document is ready and element #${elementId} does not exist`;
              if (!error.message.includes(knownErrorMsg)) {
                sendError(error);
              }
              // else: do nothing
            });
        },
      );
    },
  );
}

export function initPaypalButton(elementId, braintreeToken, config) {
  loadPayPalCheckoutScript(() => renderPayPalBtn(elementId, braintreeToken, config));
}
